interface JWTUser {
  iat: number;
  instructor: boolean;
  sub: string;
}

export interface StoredAccount {
  id: number;
  token: string;
  firstName: string;
  lastName: string;
  image: string;
}

const ACCOUNTS_KEY = 'accounts';

const decodeJWT = (token: string): JWTUser => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const decodedPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(decodedPayload);
};

export const getCurrentUser = () => {
  const storedJWT = localStorage.getItem('token');
  if (storedJWT) {
    return decodeJWT(storedJWT);
  }
  return undefined;
};

export const logout = (removeAll = false) => {
  if (removeAll) {
    localStorage.clear();
  } else {
    const currentUser = getCurrentUser();
    if (currentUser) {
      removeAccount(Number(currentUser.sub));
    }
    localStorage.removeItem('token');
  }
};

export const getStoredAccounts = (): StoredAccount[] => {
  const stored = localStorage.getItem(ACCOUNTS_KEY);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      return [];
    }
  }
  return [];
};

export const addAccount = (token: string, userInfo: { id: number; firstName: string; lastName: string; image: string }) => {
  const accounts = getStoredAccounts();
  const existingIndex = accounts.findIndex((acc) => acc.id === userInfo.id);

  const newAccount: StoredAccount = {
    id: userInfo.id,
    token,
    firstName: userInfo.firstName,
    lastName: userInfo.lastName,
    image: userInfo.image,
  };

  if (existingIndex >= 0) {
    accounts[existingIndex] = newAccount;
  } else {
    accounts.push(newAccount);
  }

  localStorage.setItem(ACCOUNTS_KEY, JSON.stringify(accounts));
};

export const removeAccount = (id: number) => {
  const accounts = getStoredAccounts();
  const filtered = accounts.filter((acc) => acc.id !== id);
  localStorage.setItem(ACCOUNTS_KEY, JSON.stringify(filtered));
};

export const switchAccount = (id: number): boolean => {
  const accounts = getStoredAccounts();
  const account = accounts.find((acc) => acc.id === id);

  if (account) {
    localStorage.setItem('token', account.token);
    return true;
  }
  return false;
};

export const getCurrentAccount = (): StoredAccount | undefined => {
  const currentUser = getCurrentUser();
  if (!currentUser) return undefined;

  const accounts = getStoredAccounts();
  return accounts.find((acc) => acc.id === Number(currentUser.sub));
};
